import React from 'react'

import LetsTalkCta from '../LetsTalkCta'
import ValueLoopDiagram from '../shared/ValueLoopDiagram'
import { getDataAiValueLoopContent } from '../../constants/dataAiValueLoopContent'

const ServiceAIValueLoop = ({ lang }) => {
  const content = getDataAiValueLoopContent(lang)
  const isEn = lang === 'en'

  return (
    <section
      className="service-ai-value-loop"
      aria-labelledby="service-ai-value-loop-heading"
    >
      <div className="content container">
        <h2 id="service-ai-value-loop-heading" className="service-ai-value-loop__heading">
          {content.heading}
        </h2>
        <div className="service-ai-value-loop__layout">
          <div className="service-ai-value-loop__copy">
            <p className="service-ai-value-loop__lead">{content.lead}</p>
            <p className="service-ai-value-loop__body">{content.body}</p>
          </div>
          <ValueLoopDiagram
            variant="light"
            steps={content.steps}
            centerLabel={content.centerLabel}
            centerSubtitle={content.centerSubtitle}
            className="service-ai-value-loop__diagram"
          />
        </div>
        <div className="service-ai-value-loop__cta">
          <LetsTalkCta
            isEn={isEn}
            tone="onDark"
            paintDrip={false}
            to={content.cta.href}
            label={content.cta.label}
            className="service-ai-value-loop__cta-link"
          />
        </div>
      </div>
    </section>
  )
}

export default ServiceAIValueLoop
